<template>
    <el-time-picker :value="dateValue" v-bind="$attrs" @input="input($event)">
    </el-time-picker>
</template>

<script>
    import moment from 'moment'
    const valueFormat = 'HH:mm:ss'

    export default {
        name: "TimePicker",
        props: {
            value: [String, Array]
        },
        inheritAttrs: false,
        computed: {
            dateValue() {
                if (Array.isArray(this.value)) {
                    return this.value.map(item => item ? new Date(moment(item, valueFormat).valueOf()) : null)
                } else if (this.value) {
                    return new Date(moment(this.value, valueFormat).valueOf())
                } else {
                    return null
                }
            }
        },
        methods: {
            input(newValue) {
                if (Array.isArray(newValue)) {
                    this.$emit('input', newValue.map(item => item ? moment(item).format(valueFormat) : null))
                } else if (newValue) {
                    this.$emit('input', moment(newValue).format(valueFormat))
                } else {
                    this.$emit('input', null)
                }
            }
        }
    }
</script>
